import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors';
import RSVPForm from './rsvp/RSVPForm';
import Footer from './Footer';
import Navigation from './Navigation';

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: ${colors.primary.lightTan};
  padding: 2rem 0 0 0; /* Remove bottom padding to eliminate gap */
  position: relative;
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-image: url('/images/cheers-2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.3);
    z-index: 2;
  }
`;

const RSVPOverlay = styled.div`
  position: absolute;
  top: 35%;
  left: 25%;
  transform: translate(-50%, -50%) rotate(-12deg);
  z-index: 5;
  font-family: 'saint-andrews-queen', serif;
  font-size: 8rem;
  color: ${colors.neutral.cream};
  pointer-events: none;
  user-select: none;
  
  @media (max-width: 1200px) {
    font-size: 6rem;
    top: 25%;
    left: 30%;
  }
  
  @media (max-width: 768px) {
    font-size: 4rem;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-5deg);
  }
  
  @media (max-width: 480px) {
    font-size: 4rem;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-5deg);
  }
`;


const ContentContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  position: relative;
  z-index: 3;
  margin-top: 100vh;
  min-height: 400px;
  margin-bottom: 0; /* Ensure no bottom margin */

  @media (max-width: 768px) {
    min-height: 450px;
  }

  @media (max-width: 480px) {
    min-height: 350px;
  }
`;

const RSVPHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Title = styled.h1`
  font-family: 'GremeryOne', serif;
  font-size: 3.5rem;
  font-weight: 700;
  color: ${colors.neutral.darkOlive};
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.p`
  font-family: 'GremeryTwo', cursive;
  font-size: 1.3rem;
  color: ${colors.neutral.darkBrown};
  font-weight: 500;
  margin-bottom: 0.5rem;
`;

const RSVPPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <BackgroundImage />
      
      <RSVPOverlay>RSV P</RSVPOverlay>
      
      <Navigation 
        textColor={colors.neutral.darkBrown}
        logoPath="/images/agave-full-logo-brn.png"
      />
      
      <ContentContainer>
        <RSVPHeader>
          <Title>RSVP</Title>
          <Subtitle>we are excited to celebrate with you</Subtitle>
        </RSVPHeader>

        <RSVPForm />
      </ContentContainer>
      <Footer backgroundColor={colors.primary.lightTan} />
    </PageContainer>
  );
};

export default RSVPPage; 